
const m = window.require("@ember/polyfills");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
